import { File } from 'backend';
import { createSupabase } from './supabase/server';

export function supabaseImageLoader({
  src,
  width,
  quality,
}: {
  src: string | File;
  width: number;
  quality?: number;
}) {
  let file = typeof src === 'string' ? src : src.filename;

  if (!file) return src;

  if (typeof src === 'string' && src.startsWith('/public')) {
    return src.replace('/public', '');
  }

  // get the image from the supabase storage
  const supabase = createSupabase();
  const { data } = supabase.storage.from('uploads').getPublicUrl(file);

  if (data?.publicUrl) {
    if (data?.publicUrl.includes('.svg')) {
      return data?.publicUrl;
    }
    // Return the Supabase URL for Next.js to handle
    return data.publicUrl;
  } else {
    return src;
  }
}

export default supabaseImageLoader;
